/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Send_ConfirmationInputs */

const en_error_crm_send_confirmation = /** @type {(inputs: Error_Crm_Send_ConfirmationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type the word shown by the dry run to approve the send.`)
};

/**
* | output |
* | --- |
* | "Type the word shown by the dry run to approve the send." |
*
* @param {Error_Crm_Send_ConfirmationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_send_confirmation = /** @type {((inputs?: Error_Crm_Send_ConfirmationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Send_ConfirmationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_send_confirmation(inputs)
});